<template>
	<div>
		<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
			<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" class="demo-form-inline" inline>
				<el-form-item label="姓名" prop="chName">
					<el-input clearable v-model="editForm.chName" class="input_200px" size="small" auto-complete="off" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="userName">
					<el-input clearable v-model="editForm.userName" class="input_200px" size="small" auto-complete="off" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="gender">
					<el-radio-group v-model="editForm.gender" class="input_200px">
						<el-radio-button :label="1">男</el-radio-button>
						<el-radio-button :label="0">女</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="工号" prop="workerNo">
					<el-input clearable v-model="editForm.workerNo" class="input_200px" size="small" auto-complete="off" placeholder="请输入工号"></el-input>
				</el-form-item>
				<el-form-item label="卡号" prop="cardNo">
					<el-input clearable v-model="editForm.cardNo" class="input_200px" size="small" auto-complete="off" placeholder="请输入卡号"></el-input>
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input clearable v-model="editForm.idCardNo" class="input_200px" size="small" auto-complete="off" placeholder="请输入身份证号"></el-input>
				</el-form-item>
				<el-form-item label="部门" prop="deptCode">
					<el-cascader
						v-model="editForm.deptCode"
						size="small"
						:options="deptData"
						class="input_200px"
						:props="{
							expandTrigger: 'hover',
							label: 'name',
							value: 'keyId',
							children: 'subList',
							checkStrictly: true
						}"
						:clearable="true"
						@change="handleChange"
					></el-cascader>
				</el-form-item>
				<el-form-item label="角色" prop="roleId">
					<el-select v-model="editForm.roleId" size="small" filterable :clearable="true" placeholder="请选择" class="input_200px">
						<el-option v-for="item in roleData" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="人员职级" prop="userRank">
					<el-input clearable v-model="editForm.userRank" class="input_200px" size="small" auto-complete="off" placeholder="请输入人员职级"></el-input>
				</el-form-item>
				<el-form-item label="人员类别" prop="userType">
					<el-select v-model="editForm.userType" size="small" filterable :clearable="true" placeholder="请选择" class="input_200px">
						<el-option v-for="item in userTypeList" :key="item.dicCode" :label="item.dicText" :value="item.dicCode"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否打卡" prop="isNeedCard">
					<el-switch v-model="editForm.isNeedCard" active-text="需要" inactive-text="不需要" :active-value="true" :inactive-value="false" class="input_200px"></el-switch>
				</el-form-item>
				<el-form-item label="联系方式" prop="phone">
					<el-input clearable v-model="editForm.phone" class="input_200px" size="small" auto-complete="off" placeholder="请输入联系方式"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="comment">
					<el-input v-model="editForm.comment" :rows="4" class="input_200px" type="textarea" placeholder="请输入内容"></el-input>
				</el-form-item>
			</el-form>

			<div class="drawer-footer">
				<el-button size="small" icon="el-icon-check" :loading="loading" @click="submitForm('editForm')">保存</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { SaveUserInfo, GetUserInfoDetail } from "../../../api/userApi.js";
import { GetDicDataListByParentCode } from "../../../api/dicDataApi.js";
export default {
	props: ["deptData", "roleData"],
	data() {
		return {
			title: "新增",
			Organization: [],
			options: [],
			editFormVisible: false, //控制编辑页面显示与隐藏
			loading: false, //是显示加载
			rules: {
				userName: [
					{
						required: true,
						message: "请输入用户名",
						trigger: "blur"
					}
				],
				gender: [
					{
						required: true,
						message: "请选择性别",
						trigger: "blur"
					}
				],
				chName: [
					{
						required: true,
						message: "请输入姓名",
						trigger: "blur"
					}
				],
				cardNo: [
					{
						required: true,
						message: "请输入卡号",
						trigger: "blur"
					}
				],
				workerNo: [
					{
						required: true,
						message: "请输入工号",
						trigger: "blur"
					}
				],
				deptCode: [
					{
						required: true,
						message: "请选择部门",
						trigger: "blur"
					}
				],
				idCardNo: [
					{
						required: true,
						message: "请输入身份证号",
						trigger: "blur"
					}
				]
			},
			// 编辑表单
			editForm: {
				keyId: "",
				userName: "",
				chName: "",
				gender: 1,
				workerNo: "",
				cardNo: "",
				idCardNo: "",
				deptCode: "",
				photoImg: "",
				signImg: "",
				roleId: "",
				isActive: true,
				userRank: "",
				userType: "",
				comment: "",
				phone: "",
				isNeedCard: true
			},

			userTypeList: []
		};
	},
	created() {},
	methods: {
		// change事件
		handleChange(value) {
			this.editForm.deptCode = value[value.length - 1];
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$refs["editForm"].resetFields();
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.loading = true;
					SaveUserInfo(this.editForm)
						.then((res) => {
							this.loading = false;
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "保存成功！"
								});
								this.editFormVisible = false;
								this.$parent.getListData();
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},

		//显示编辑界面
		editShow(row) {
			this.getUserType();
			if (row != undefined && row != "undefined") {
				let parameter = {
					keyId: row.keyId
				};
				let temp = row.roleId;
				this.title = "编辑";
				GetUserInfoDetail(parameter)
					.then((res) => {
						if (res.code == 1) {
							this.editForm = res.data;
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("加载失败，请稍后再试！");
					});

				this.editForm.keyId = row.keyId;
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
			}
		},

		// 获取人员类型
		getUserType() {
			let parmter = {
				parentCode: "UserType"
			};
			GetDicDataListByParentCode(parmter)
				.then((res) => {
					if (res.code == 1) {
						this.userTypeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		}
	}
};
</script>
<style scoped>
.information {
	font-size: 14px;
	padding: 5px 20px 10px 20px;
	font-weight: 600;
}

.box {
	margin: 20px 20px 0;
	/* border-bottom: 1px solid var(--app-border-strong); */
}

.pad10 {
	padding: 0 0 20px 40px;
}

.input-width {
	max-width: 360px;
	padding-left: 10px;
}

.box .pattern {
	width: 200px;
	height: 250px;
	vertical-align: text-top;
}

.mr {
	margin-right: 10px;
}

.capsule-l {
	width: 100px;
	border-radius: 100px 0 0 100px;
}

.capsule-r {
	width: 100px;
	margin-left: 0;
	border-radius: 0 100px 100px 0;
}
</style>
